import { getStateWithOnlyOneLevel } from '../../utils/StateSelectorHelper';

function getState(state) {
  return getStateWithOnlyOneLevel(state, 'studyMain');
}

export const getContentByRefSelector = (state) =>
  getState(state).get('contentByReference');

export const getContentByReferenceFetchedSelector = (state) =>
  getState(state).get('contentByReferenceFetched');

export const getContentByReferenceFetchingSelector = (state) =>
  getState(state).get('contentByReferenceFetching');

export const getContentByWarfareQualsSelector = (state) =>
  getState(state).get('contentByWarfareQuals');

export const getQuestionsDataSelector = (state) =>
  getState(state).get('questionsData');

export const getQuestionSelector = (state) => getState(state).get('question');

export const getPreviousQuestionSelector = (state) =>
  getState(state).get('previousQuestion');

export const getPreviousCountersSelector = (state) =>
  getState(state).get('previousCounters');

export const getCountersSelector = (state) => getState(state).get('counters');

export const getQuestionsSelector = (state) => getState(state).get('questions');

export const qualFromIdSelector = (state) => getState(state).get('qual');

export const isLoadingQuestionsSelector = (state) =>
  getState(state).get('isLoadingQuestions');

export const errorMessageGetQuestionSelector = (state) =>
  getState(state).get('errorMessage');

// studyplan
function getStateStudyPlan(state) {
  return getStateWithOnlyOneLevel(state, 'studyPlan');
}
export const studyPlanSelector = (state) =>
  getStateStudyPlan(state).get('contentStudyPlan');

export const getBackToSelector = (state) => getState(state).get('backTo');

export const getCountQuestions = (state) =>
  getState(state).get('countQuestions');
export const getRecaptchaTime = (state) => getState(state).get('recaptchaTime');
export const getChapterId = (state) => getState(state).get('chapterId');
export const getResetChapter = (state) =>
  getState(state).get('getResetChapter');
export const getLoadResetChapter = (state) =>
  getState(state).get('loadResetChapter');
export const updateUserAnswers = (state) => getState(state).get('userAnswers');
export const getAnswerResponse = (state) =>
  getState(state).get('answerResponse');
export const getPdfLink = (state) => getState(state).get('pdfLink');
export const isLoadingPdfLink = (state) =>
  getState(state).get('isLoadingPdfLink');
export const getPostExamChecklistPdfLink = (state) =>
  getState(state).get('postExamChecklistPdfLink');
export const isLoadingPostExamChecklistPdf = (state) =>
  getState(state).get('isLoadingPostExamChecklistPdf');
export const isLoadingReferences = (state) =>
  getState(state).get('isLoadingReferences');
export const getIsLoadingSktData = (state) =>
  getState(state).get('isLoadingSktData');
export const getBreadcrums = (state) =>
  getState(state).get('breadcrumsQualsAndCerts');
export const loadFavoriteQuestionSelector = (state) =>
  getState(state).get('loadFavoriteQuestion');
export const setFavoriteMessageSelector = (state) =>
  getState(state).get('setFavoriteMessage');
export const isStudyFavoriteQuestionSelector = (state) =>
  getState(state).get('isStudyFavoriteQuestion');
export const counterFavoriteSelector = (state) =>
  getState(state).get('counterFavorite');
export const counterMySubmittedSelector = (state) =>
  getState(state).get('counterMySubmitted');
export const counterMyFavoriteSelector = (state) =>
  getState(state).get('counterMyFavorite');
export const counterSubmittedSelector = (state) =>
  getState(state).get('counterSubmitted');
export const submittedListQuestionsSelector = (state) =>
  getState(state).get('submittedQuestions');
export const isStudyingSubmittedQuestionsSelector = (state) =>
  getState(state).get('isStudyingSubmittedQuestions');
export const isStudyingMyFavoriteQuestionsSelector = (state) =>
  getState(state).get('isStudyingMyFavoriteQuestions');
export const isStudyingMySubmittedQuestionsSelector = (state) =>
  getState(state).get('isStudyingMySubmittedQuestions');
export const getMoreQuestionsSelector = (state) =>
  getState(state).get('moreQuestions');
export const getAudioPlaylistSelector = (state) =>
  getState(state).get('audioPlaylist');
export const getAudioPlaylistsProgressSelector = (state) =>
  getState(state).get('audioPlaylistsProgressByChapter');
export const getAudioPlaylistsProgressFetchedSelector = (state) =>
  getState(state).get('audioPlaylistsProgressFetched');
export const getAudioPlaylistsProgressFetchingSelector = (state) =>
  getState(state).get('audioPlaylistsProgressFetching');
export const getResetChapterMessage = (state) =>
  getState(state).get('resetChapterMessage');
export const getQuestionSKTCount = (state) =>
  getState(state).get('questionSKTCount');
export const getChaptersSKTCount = (state) =>
  getState(state).get('chaptersSKTCount');
export const getChaptersSKTWithoutQuestions = (state) =>
  getState(state).get('chaptersSKTWithoutQuestions');
